import React from "react";
import { Outlet } from "react-router";
import AuthProvider from "@/shared/contexts/auth.context";
import ErrorBoundary from "@/shared/widgets/ErrorBoundary";
import { ModalProvider } from "@/shared/contexts/modal.context";
import { TooltipProvider } from "@/shared/ui/Tooltip";
import { SocketProvider } from "@/shared/contexts/socket.context";
import { EventProvider } from "@/shared/contexts/event.context";
import { ToastProvider } from "@/shared/contexts/toast.context";
import GptProvider from "@/shared/contexts/gptgateway.context";

export function Layout() {
  return (
    <ErrorBoundary>
      <ToastProvider>
        <EventProvider>
          <AuthProvider>
            <TooltipProvider delayDuration={300}>
              <SocketProvider>
                <GptProvider>
                  <ModalProvider>
                    <Outlet />
                  </ModalProvider>
                </GptProvider>
              </SocketProvider>
            </TooltipProvider>
          </AuthProvider>
        </EventProvider>
      </ToastProvider>
    </ErrorBoundary>
  );
}
